// src/pages/Home.jsx

import React, { useEffect } from "react";
import "./Home.css";
import head from "../images/head1.webp";
// import Testimonials from "./Testimonials";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faUserGraduate,
  faChalkboardTeacher,
  faHandsHelping,
  faChartLine,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import course1 from "../images/course.webp";
import course2 from "../images/course1.webp";
import course3 from "../images/course2.webp";
import AOS from "aos";
import "aos/dist/aos.css";
// import Carousel from "../components/CarouselComponent";
import CardList from "../components/CardList";
// import ScrollIndicator from "../components/Scrolldown";
const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <header>
        <div
          id="Header"
          className="container header__container"
          data-aos="fade-up"
        >
          <div className="header__left">
            <h1>Welcome to JEE Vision Coaching</h1>
            <p>
              We specialize in preparing students of 11th and 12th grade for JEE
              IIT with expert math coaching.
            </p>
            <Link to="/courses">
              <button className="animated-button">
                <svg
                  viewBox="0 0 24 24"
                  className="arr-2"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
                <span className="text">Get Started</span>
                <span className="circle"></span>
                <svg
                  viewBox="0 0 24 24"
                  className="arr-1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
                </svg>
              </button>
            </Link>
          </div>
          <div className="header__right">
            <div className="header__right-image">
              <img src={head} alt="" />
            </div>
          </div>
        </div>
      </header>
      {/* <ScrollIndicator /> */}

      <section
        id="about"
        className="categories"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div className="container categories__container">
          <div className="categories__left" data-aos="fade-right">
            <h1>Why Choose Jee Vision?</h1>
            <p>
              At JEE Vision Coaching, we focus on helping students excel in
              mathematics and achieve their IIT dreams. Our single, dedicated
              math teacher provides personalized attention and a structured
              learning experience tailored to each student's needs. Join us for
              expert coaching designed to maximize your potential.
            </p>
            <Link to="/About">
              <button className="button">Learn More</button>
            </Link>
          </div>
          <div className="categories__right">
            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faClipboardList} />
              </span>
              <h5>Regular Assessments</h5>
              <p>
                Conducting tests and assessments at regular intervals to gauge
                students' understanding and progress.
              </p>
            </article>

            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="100"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faUserGraduate} />
              </span>
              <h5>Personalized Guidance</h5>
              <p>
                Offering individualized attention to students, helping them
                address their specific academic needs and challenges.
              </p>
            </article>

            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="200"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faChalkboardTeacher} />
              </span>
              <h5>Structured Learning</h5>
              <p>
                Providing a structured curriculum aligned with exam syllabi,
                ensuring comprehensive coverage of topics.
              </p>
            </article>

            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="300"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faHandsHelping} />
              </span>
              <h5>Career Counseling</h5>
              <p>
                Offering guidance on career paths, university admissions, and
                exam strategies beyond academic tutoring.
              </p>
            </article>

            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="400"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faChartLine} />
              </span>
              <h5>Performance Analysis</h5>
              <p>
                Analyzing test results to identify strengths and weaknesses.
              </p>
            </article>

            <article
              className="category"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="500"
            >
              <span className="category__icon">
                <FontAwesomeIcon icon={faUsers} />
              </span>
              <h5>Small Batch Sizes</h5>
              <p>Ensuring personalized attention with small class sizes.</p>
            </article>
          </div>
        </div>
      </section>

      <section id="courses" className="courses">
        <h2 data-aos="fade-up">Our Popular Courses</h2>
        <div className="container courses__container">
          <article className="course" data-aos="zoom-in" data-aos-delay="100">
            <div className="course__image">
              <img className="img" src={course1} alt="" />
            </div>
            <div className="course__info">
              <h4>Integration</h4>
              <p>
                Integration is used to find areas under curves and solve
                differential equations. This course covers substitution,
                integration by parts, and partial fractions, with real-world
                applications in physics and engineering.
              </p>
              <Link to="/courses" className="btn btn-primary">
                Learn More
                {/* <button className="bttn">
                  <span>Learn More</span>
                  <svg
                    width="34"
                    height="34"
                    viewBox="0 0 74 74"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="37"
                      cy="37"
                      r="35.5"
                      stroke="white"
                      strokeWidth="3"
                    ></circle>
                    <path
                      d="M25 35.5C24.1716 35.5 23.5 36.1716 23.5 37C23.5 37.8284 24.1716 38.5 25 38.5V35.5ZM49.0607 38.0607C49.6464 37.4749 49.6464 36.5251 49.0607 35.9393L39.5147 26.3934C38.9289 25.8076 37.9792 25.8076 37.3934 26.3934C36.8076 26.9792 36.8076 27.9289 37.3934 28.5147L45.8787 37L37.3934 45.4853C36.8076 46.0711 36.8076 47.0208 37.3934 47.6066C37.9792 48.1924 38.9289 48.1924 39.5147 47.6066L49.0607 38.0607ZM25 38.5L48 38.5V35.5L25 35.5V38.5Z"
                      fill="white"
                    ></path>
                  </svg>
                </button> */}
              </Link>
            </div>
          </article>

          <article className="course" data-aos="zoom-in" data-aos-delay="200">
            <div className="course__image">
              <img className="img" src={course2} alt="" />
            </div>
            <div className="course__info">
              <h4>Function</h4>
              <p>
                Functions represent relationships between variables. This course
                covers linear, quadratic, and exponential functions, focusing on
                domain, range, and practical applications.
              </p>
              <Link to="/courses" className="btn btn-primary">
                Learn More
              </Link>
            </div>
          </article>

          <article className="course" data-aos="zoom-in" data-aos-delay="300">
            <div className="course__image">
              <img className="img" src={course3} alt="" />
            </div>
            <div className="course__info">
              <h4>Trigonometry</h4>
              <p>
                Trigonometry explores the relationships between triangle sides
                and angles. This course covers sine, cosine, and tangent
                functions, along with identities and equations, with
                applications in physics and engineering.
              </p>
              <Link to="/courses" className="btn btn-primary">
                Learn More
              </Link>
            </div>
          </article>
        </div>
      </section>
      {/* <Carousel /> */}
      {/* <Testimonials /> */}
      <h1 className="test">Students' Testimonials</h1>
      <CardList />
    </>
  );
};

export default Home;
